import $ from 'jquery';
import { AdaSupport } from '../../components/modules/ada-support';

$(window).on('load', () => {
  const activitiesBlock = $('.activities');
  activitiesBlock.each((ind, elem) => {
    const activitiesItem = $(elem).find('.activities__link');
    const activitiesContainer = $(elem).find('.activities__container');

    if ($('body').hasClass('samoset-site')) {
      activitiesItem.removeClass('active');
      activitiesItem.last().show().addClass('active');
      activitiesContainer.not(':last').hide();
    } else {
      activitiesContainer.not(':first').hide();
      activitiesItem.first().show().addClass('active');
    }

    activitiesItem.each((index, el) => {
      $(el).attr('data-tab', index);
    });
    activitiesContainer.each((index, el) => {
      $(el).attr('data-tab', index);
    });
    activitiesItem.on('click', function () {
      const dataTab = $(this).data('tab');
      activitiesItem.removeClass('active');
      $(this).addClass('active');
      activitiesContainer.hide();
      $(elem).find(`.activities__container[data-tab=${dataTab}]`).show();
    });
  });
  const tabs = $('.tab');
  AdaSupport(tabs);
});
